import React, { Fragment } from 'react';
import './notification-component.scss';
import { NOTIFICATION_TYPE, CLICK_TYPE } from './notification.constant';

const Notification = ({ show = false, type = NOTIFICATION_TYPE.SUCCESS, message, eventHandler = () => {}, hideCancelButton = false, onCancel = () => {} }) => {
  const onMessageClick = (event) => {
    const { innerText, dataset } = event && event.target;
    if (dataset && dataset.type === CLICK_TYPE.LINK) {
      eventHandler && eventHandler({ nodeInfo: dataset, event: event, innerText });
    }
  };

  const renderNotification = (type) => {
    return (
      <div className="single_upgrade_notification">
        <div className="custom_notification">
          <div className={`coverageContent ${type ? type : NOTIFICATION_TYPE.DEFAULT}`} onClick={onMessageClick}>
            {message}
          </div>
        </div>
      </div>
    );
  };
  return show ? <Fragment>{renderNotification(type)}</Fragment> : null;
};

export { Notification, NOTIFICATION_TYPE, CLICK_TYPE };
